import {Store,Module,ActionContext} from 'vuex'
import ListModule from './list-module'
import ListState from './list-state'
import OrderManagement from '../entities/ordermanagement'
import CompanyInformation from '../entities/companyinformation'
import WasteType from '../entities/wastetype'
import Ajax from '../../lib/ajax'
import PageResult from '@/store/entities/page-result';
import ListMutations from './list-mutations'
interface OrderManagementState extends ListState<OrderManagement>{
    editOrderManagement:OrderManagement;
    wastetypes:WasteType[],
    companyinformations:CompanyInformation[],
    ykcflist: object,
    cflistid:object;
    cklist:object,
    ghlist:object;
    citylist:object,
    countylist:object,
    villageslist:object,
    czlist: object,
    
}
class OrderManagementModule extends ListModule<OrderManagementState,any,OrderManagement>{
    state={
        totalCount:0,
        currentPage:1,
        pageSize:10,
        list: new Array<OrderManagement>(),
        loading:false,
        editOrderManagement:new OrderManagement(),
        wastetypes:new Array<WasteType>(),
        companyinformations:new Array<CompanyInformation>(),
        isShowStatus:true,
        statusselected:0,
        statuslist:[{ 'id':0,name:'Pending'},{ 'id':1,name:'Intransit'},{ 'id':2,name:'Dreceipt'},{ 'id':3,name:'Signfor'}],
        ordertype:[{id:1,name:'Warehousing'},{id:2,name:'Outbound'},{id:3,name:'Dispose'},{id:4,name:'Drying'}],
        isdispose:false, //判断是否处置订单
        type:0, //订单类型
        ykcflist: new Array<OrderManagement>(),
        cflistid:new Array(),
        cklist: new Array<OrderManagement>(),
        ghlist: new Array<OrderManagement>(),
        czlist: new Array<OrderManagement>(),
        regionlist:new Array(),
        citylist:new Array(),
        countylist:new Array(),
        villageslist:new Array()


        
    }
    actions={
        async getAll(context:ActionContext<OrderManagementState,any>,payload:any){
            context.state.loading=true;
            let reponse=await Ajax.get('/api/services/app/OrderManagement/GetAll',{params:payload.data});
            context.state.loading=false;
            let page=reponse.data.result as PageResult<OrderManagement>;
            context.state.totalCount=page.totalCount;
            context.state.list=page.items;
        },

        async getStatisticsDataCompanyInformationTimeInput(context:ActionContext<OrderManagementState,any>,payload:any){
         
            let reponse=await Ajax.get('/api/services/app/OrderManagement/GetStatisticsDataCompanyInformationTimeInput',{params:payload.data});
            
            let page=reponse.data.result as PageResult<OrderManagement>;
           
            context.state.ykcflist=page;
        },
        async getSignforStatisticsDataTime(context:ActionContext<OrderManagementState,any>,payload:any){
         
            let reponse=await Ajax.get('/api/services/app/OrderManagement/GetSignforStatisticsDataTime',{params:payload.data});
            
            let page=reponse.data.result as PageResult<OrderManagement>;
           
            context.state.czlist=page;
        },

        async getStatisticsDataTime(context:ActionContext<OrderManagementState,any>,payload:any){
         
            let reponse=await Ajax.get('/api/services/app/OrderManagement/GetStatisticsDataTime',{params:payload.data});
            
            let page=reponse.data.result as PageResult<OrderManagement>;
             
            if(payload.data.type==2){
                context.state.cklist=page
            }
            if(payload.data.type==4){
                context.state.ghlist=page
            }
            
        },




        async create(context:ActionContext<OrderManagementState,any>,payload:any){
            console.log("create")
            console.log(payload.data)
            await Ajax.post('/api/services/app/OrderManagement/Create',payload.data);
        },
        async update(context:ActionContext<OrderManagementState,any>,payload:any){
            await Ajax.put('/api/services/app/OrderManagement/Update',payload.data);
        },

        async updatestatus(context:ActionContext<OrderManagementState,any>,payload:any){
            await Ajax.put('/api/services/app/OrderManagement/UpdateState',payload.data);
        },
        async delete(context:ActionContext<OrderManagementState,any>,payload:any){
            await Ajax.delete('/api/services/app/OrderManagement/Delete?Id='+payload.data.id);
        },
        async get(context:ActionContext<OrderManagementState,any>,payload:any){
            let reponse=await Ajax.get('/api/services/app/OrderManagement/Get?Id='+payload.id);
            return reponse.data.result as OrderManagement;
        },
        async getCompanyInformation(context:ActionContext<OrderManagementState,any>){
            
            let reponse=await Ajax.get('/api/services/app/CompanyInformation/GetAllList');
             
          
            


            context.state.companyinformations=reponse.data.result as CompanyInformation[];
        },
        async getWasteType(context:ActionContext<OrderManagementState,any>){
            let reponse=await Ajax.get('/api/services/app/WasteType/GetAllList');
            context.state.wastetypes=reponse.data.result as WasteType[];
        },

    };
    mutations={
        setCurrentPage(state:OrderManagementState,page:number){
            state.currentPage=page;
        },
        setPageSize(state:OrderManagementState,pagesize:number){
            state.pageSize=pagesize;
        },
        edit(state:OrderManagementState,ordermanagement:OrderManagement){
            state.editOrderManagement=ordermanagement;
        },
        change_citylist(state:OrderManagementState,vaue:[]){

            state.citylist=vaue;
          
        },
        change_countylist(state:OrderManagementState,vaue:[]){
 
            state.countylist=vaue;
          
        },
        change_villageslist(state:OrderManagementState,vaue:[]){

            state.villageslist=vaue;
          
        },
    }
}
const ordermanagementModule=new OrderManagementModule();
export default ordermanagementModule;